import React from 'react';

import { FiltersOptionsByKey } from '@ihme/common/types';
import { withStorage, WithStorageProps } from '@ihme/common/packages/storage';
import { Clearfix, Form } from '@ihme/common/web/components';
import _ from '@ihme/common/locale';
import styled from '@ihme/common/theme/styled';

import ChartDropdown from '../../components/ChartDropdown';
import AgeGroupsDropdown from '../../components/AgeGroupsDropdown';
import MetricsDropdown from '../../components/MetricsDropdown';
import config from '../../config';
import HierarchicalDropdown from '../../components/HierarchicalDropdown';
import api from '../../api';

const ButtonGroup = styled.div(({ theme }) => ({
    marginBottom: 10,
    '> *': {
        width: 200,
        marginRight: 12,
        marginBottom: 10,
        [theme.breakpoint.xs]: {
            width: 252,
        },
    },
}));

const LocationsDropdown = styled(HierarchicalDropdown)(({ theme }) => ({
    width: 412,
    [theme.breakpoint.xs]: {
        width: '100%',
    },
}));

type Props = WithStorageProps & {
    refinedGranularity: FiltersOptionsByKey;
};

class BreakdownChartFilters extends React.Component<Props> {
    limitSelectedLocations = locationIds => locationIds.slice(Math.max(locationIds.length - 3, 0));

    render() {
        const { cached, refinedGranularity } = this.props;

        return (
            <Form inline>
                <ButtonGroup>
                    <LocationsDropdown
                        loadHierarchy={cached(api.getLocations)}
                        label={_('filter_location_title').toUpperCase()}
                        localePrefix="location_"
                        filterKey="location_id"
                        preprocessChange={this.limitSelectedLocations}
                        isSearchable
                        isMulti
                        showPrefix
                        useLetterPrefix={false}
                    />
                    <ChartDropdown
                        label={_('filter_measure_title').toUpperCase()}
                        localePrefix="measure_"
                        filterKey="measure_id"
                        preprocessOptions={options =>
                            options.filter(
                                ({ value }) => value !== config.maternalMortalityRatioMeasureId
                            )
                        }
                    />
                    <AgeGroupsDropdown />
                    <MetricsDropdown refinedOptions={refinedGranularity.metric_id} />
                    <ChartDropdown label={_('filter_year_title').toUpperCase()} filterKey="year" />
                </ButtonGroup>
                <Clearfix />
            </Form>
        );
    }
}

export default withStorage(BreakdownChartFilters);
